import { render } from "./UnderDevelopment.vue?vue&type=template&id=0c5754ce&scoped=true"
import script from "./UnderDevelopment.vue?vue&type=script&lang=js"
export * from "./UnderDevelopment.vue?vue&type=script&lang=js"

import "./UnderDevelopment.vue?vue&type=style&index=0&id=0c5754ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5754ce"]])

export default __exports__